import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"

import {computed} from 'vue';
import OrderNotificationCard from '@/components/Layout/LayoutV2/Notifications/OrderNotificationCard.vue';
import {h} from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'NotificationsComponent',
  props: {
  notifications: {
    type: Array,
    default: () => []
  }
},
  emits: ['onClose'],
  setup(__props, { emit: __emit }) {

const emit = __emit

const props = __props

const getComponent = (notification) => {
  return h(
      OrderNotificationCard,
      {
        notification,
        onClose: (notification) => emit('onClose', notification)
      }
  )
}

/**
 * Get the container style based on the number of notifications
 */
const getContainerStyle = computed(() => {
  let height = 0;

  switch (props.notifications.slice(0, 3).length) {
    case 1:
      height = 110;
      break;
    case 2:
      height = 130;
      break;
    case 3:
      height = 150;
      break;
  }

  return {
    minHeight: `${height}px`
  }
})

/**
 * Get the style for the notification card
 * @param index
 */
const getStyle = (index: number) => {
  const zIndex = props.notifications.length - index;
  const top = index > 0 ? index === 1 ? `${index * 30}px` : `${index * 23}px` : '0px';
  const width = index > 0 ? index === 1 ? `98%` : '94%' : '100%';
  return {
    zIndex: zIndex,
    top: top,
    width: width,
    right: 0,
    left: 0,
    margin: 'auto',
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle(getContainerStyle.value),
    class: "position-relative w-100 mx-5"
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.notifications.slice(0, 3), (notification, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: notification.id
      }, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(getComponent(notification)), {
          style: _normalizeStyle(getStyle(index)),
          class: "position-absolute"
        }, null, 8, ["style"]))
      ]))
    }), 128))
  ], 4))
}
}

})